/**
 * Pronto · usePropertyEnhanceStatus — iter v33 r18.
 *
 * Contesto: user M1505-M1506 «se generi un reel/social mentre l'enhance
 * foto è ancora in corso, il container va sotto pressione e ffmpeg
 * crasha con 500 spaventoso». Fix: polla lo stato dei kit-jobs
 * dell'annuncio e ritorna `enhanceInProgress` + progresso. I componenti
 * "pesanti" (SocialStudioTab, editor reel) usano questo per DISABILITARE
 * i pulsanti Genera finché le foto non sono pronte, evitando l'errore.
 *
 * API:
 *   const { enhanceInProgress, done, total, remaining } = usePropertyEnhanceStatus(propertyId);
 *
 * enhanceInProgress: true se c'è un job `enhance_photos` in stato non-terminal.
 * done/total/remaining: contatore foto migliorate.
 */
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function usePropertyEnhanceStatus(propertyId, { pollInterval = 4000, enabled = true } = {}) {
  const [state, setState] = useState({
    enhanceInProgress: false,
    done: 0,
    total: 0,
    remaining: 0,
    ready: false,
  });

  useEffect(() => {
    if (!propertyId || !enabled) return undefined;
    let cancelled = false;

    const check = async () => {
      try {
        const { data } = await api.get(`/properties/${propertyId}/kit-jobs`);
        if (cancelled) return;
        const jobs = data?.jobs || [];
        const enhanceJob = jobs.find((j) => j.kind === "enhance_photos");
        if (!enhanceJob) {
          setState({ enhanceInProgress: false, done: 0, total: 0, remaining: 0, ready: true });
          return;
        }
        const status = enhanceJob.status;
        const done = enhanceJob.count || 0;
        const total = enhanceJob.total || 0;
        const remaining = Math.max(0, total - done);
        const isActive = status === "queued" || status === "processing" || (status === "pending" && remaining > 0);
        setState({
          enhanceInProgress: isActive,
          done,
          total,
          remaining,
          ready: !isActive && status === "ready",
        });
      } catch {
        // Silenzioso — non è critico, ci riproviamo al prossimo tick
      }
    };

    check();
    const iv = setInterval(check, pollInterval);
    return () => { cancelled = true; clearInterval(iv); };
  }, [propertyId, pollInterval, enabled]);

  return state;
}
